module.exports = __webpack_public_path__ + "img/logo.9f8176c6.svg";